export const TOGGLE_CHECK = "portalrh@TOGGLE_CHECK";
export const GET_CHECK = "portalrh@GET_CHECK";
export const SET_CHECK = "portalrh@SET_CHECK";
export const REDIRECT_USER_TO = "portalrh@REDIRECT_USER_TO";
export const CLEAR_CHECK = "portal@CLEAR_CHECK";

export const GET_DOCUMENTS = "portalrh@GET_DOCUMENTS";
export const SET_DOCUMENTS = "portalrh@SET_DOCUMENTS";
export const SAVE_DOCUMENTLIST = "portal@SAVE_DOCUMENTLIST";
export const DELETE_DOCUMENT = "portal@DELETE_DOCUMENT";
export const CLEAR_DOCUMENTS = "portal@CLEAR_DOCUMENTS";
export const GET_DOCUMENT = "portal@GET_DOCUMENT";
export const CLEAR_DOCUMENT = "portal@CLEAR_DOCUMENT";
export const SET_DOCUMENT = "portal@SET_DOCUMENT";
export const SUCCESS_DELETE = "portal@SUCCESS_DELETE";

export const GET_OPERATIONS = "portalrh@GET_OPERATIONS";
export const SET_OPERATIONS = "portalrh@SET_OPERATIONS";

export const GET_PREVIEW = "portalrh@GET_PREVIEW";
export const SET_PREVIEW = "portalrh@SET_PREVIEW";

export const UPDATE_DOCUMENT = "portal@UPDATE_DOCUMENT";
export const GET_COLLABORATORS = "portal@GET_COLLABORATORS";
export const SET_COLLABORATORS = "portal@SET_COLLABORATORS";

export const GET_DOCUMENTS_ADMIN = "portalrh@GET_DOCUMENTS_ADMIN";
export const SET_DOCUMENTS_ADMIN = "portalrh@SET_DOCUMENTS_ADMIN";
export const FIND_DOCUMENTS_BY_FILTERS = "portal@FIND_DOCUMENTS_BY_FILTERS";

export const GET_REQUESTS_BY_USERNAME = "portalrh@GET_REQUESTS_BY_USERNAME";
export const SET_REQUESTS_BY_USERNAME = "portalrh@SET_REQUESTS_BY_USERNAME";

export const CHECK_UPDATE_BY_USERNAME = "portal@CHECK_UPDATE_BY_USERNAME";

export const SET_GENERIC_REQUEST_STATE = "portal@SET_GENERIC_REQUEST_STATE";
export const SET_GENERIC_AUTHORIZATION_STATE =
  "portal@SET_GENERIC_AUTHORIZATION_STATE";

export const GET_USER_PAYDATA = "portal@GET_USER_PAYDATA";
export const SET_USER_PAYDATA = "portal@SET_USER_PAYDATA";
export const GET_USER_SYNCHRONIZATION_LOG =
  "portal@GET_USER_SYNCHRONIZATION_LOG";
export const SET_USER_SYNCHRONIZATION_LOG =
  "portal@SET_USER_SYNCHRONIZATION_LOG";

export const GET_OBJECTIVES = "portal@GET_OBJECTIVES";
export const SET_OBJECTIVES = "portal@SET_OBJECTIVES";

export const GET_OBJECTIVE_BY_ID = "portal@GET_OBJECTIVE_BY_ID";
export const SET_OBJECTIVE_BY_ID = "portal@SET_OBJECTIVE_BY_ID";

export const GET_EVALUATION_SYSTEMS = "portal@GET_EVALUATION_SYSTEMS";
export const SET_EVALUATION_SYSTEMS = "portal@SET_EVALUATION_SYSTEMS";

export const GET_EVALUATION_PERIODS = "portal@GET_EVALUATION_PERIODS";
export const SET_EVALUATION_PERIODS = "portal@SET_EVALUATION_PERIODS";

export const GET_USER_INFORMATIONS = "portalrh@GET_USER_INFORMATIONS";
export const SET_USER_INFORMATIONS = "portalrh@SET_USER_INFORMATIONS";

export const UPDATE_OPERATION_STATES = "portalrh@UPDATE_OPERATION_STATES";

export const GET_DOCS_DISCLAIMERS = "portalrh@GET_DOCS_DISCLAIMERS";
export const SET_DOCS_DISCLAIMERS = "portalrh@SET_DOCS_DISCLAIMERS";

export const UPDATE_DOCS_DISCLAIMER = "portalrh@UPDATE_DOCS_DISCLAIMER";

export const STOP_EDITING_DOCS_DISCLAIMERS =
  "portalrh@STOP_EDITING_DOCS_DISCLAIMERS";

export const UPLOAD_SCHEDULE = "portalrh@UPLOAD_SCHEDULE";
export const STOP_UPLOAD_SCHEDULE = "portalrh@STOP_UPLOAD_SCHEDULE";

export const UPLOAD_ATTENDANCE = "portalrh@UPLOAD_ATTENDANCE";
export const STOP_UPLOAD_ATTENDANCE = "portalrh@STOP_UPLOAD_ATTENDANCE";

export const GET_ENTITIES = "portalrh@GET_ENTITIES";
export const SET_ENTITIES = "portalrh@SET_ENTITIES";

export const GET_ENTITIES_ATTENDANCE = "portalrh@GET_ENTITIES_ATTENDANCE";
export const SET_ENTITIES_ATTENDANCE = "portalrh@SET_ENTITIES_ATTENDANCE";

export const GET_LOGS = "portalrh@GET_LOGS";
export const SET_LOGS = "portalrh@SET_LOGS";

export const GET_ATTENDANCE_LOGS = "portalrh@GET_ATTENDANCE_LOGS";
export const SET_ATTENDANCE_LOGS = "portalrh@SET_ATTENDANCE_LOGS";

export const GET_EXPORT_LOGS = "portalrh@GET_EXPORT_LOGS";
export const SET_EXPORT_LOGS = "portalrh@SET_EXPORT_LOGS";

export const toggleCheck = () => {
  return { type: TOGGLE_CHECK };
};
export const getCheck = () => {
  return { type: GET_CHECK };
};
export const setCheck = (data) => {
  return { type: SET_CHECK, data };
};
export const redirectUserTo = (path) => {
  return { type: REDIRECT_USER_TO, path };
};
export const clearCheck = () => {
  return { type: CLEAR_CHECK };
};

export const getDocuments = () => {
  return { type: GET_DOCUMENTS };
};
export const setDocuments = (documents) => {
  return { type: SET_DOCUMENTS, documents };
};
export const saveDocumentList = (docList, uploadEmMassa) => {
  return { type: SAVE_DOCUMENTLIST, docList, uploadEmMassa };
};
export const deleteDocument = (docId) => {
  return { type: DELETE_DOCUMENT, docId };
};
export const clearDocuments = () => {
  return { type: CLEAR_DOCUMENTS };
};
export const setSuccessDelete = () => {
  return { type: SUCCESS_DELETE };
};

export const getDocumentBinary = (id) => {
  return { type: GET_DOCUMENT, id };
};
export const setDocument = (document) => {
  return { type: SET_DOCUMENT, document };
};
export const clearDocument = () => {
  return { type: CLEAR_DOCUMENT };
};

export const getOperations = (t) => {
  return { type: GET_OPERATIONS, t };
};
export const setOperations = (operations) => {
  return { type: SET_OPERATIONS, operations };
};

export const getPreviewBinary = (id) => {
  return { type: GET_PREVIEW, id };
};
export const setPreviewBinary = (preview) => {
  return { type: SET_PREVIEW, preview };
};

export const updateDocument = (document) => {
  return { type: UPDATE_DOCUMENT, document };
};
export const getCollaborators = () => {
  return { type: GET_COLLABORATORS };
};
export const setCollaborators = (users) => {
  return { type: SET_COLLABORATORS, users };
};

export const getDocumentsAdmin = () => {
  return { type: GET_DOCUMENTS_ADMIN };
};
export const setDocumentsAdmin = (documents) => {
  return { type: SET_DOCUMENTS_ADMIN, documents };
};
export const findDocumentsByFilters = (filters) => {
  return { type: FIND_DOCUMENTS_BY_FILTERS, filters };
};

export const getRequestsByUsername = (username, procGeneric) => {
  return { type: GET_REQUESTS_BY_USERNAME, username, procGeneric };
};
export const setRequestsByUsername = (requests) => {
  return { type: SET_REQUESTS_BY_USERNAME, requests };
};

export const checkUpdateByUsername = (username) => {
  return { type: CHECK_UPDATE_BY_USERNAME, username };
};

export const getUserPayData = (funcionarioNum) => {
  return { type: GET_USER_PAYDATA, funcionarioNum };
};

export const setUserPayData = (userPayData) => {
  return { type: SET_USER_PAYDATA, userPayData };
};

export const getUserInformations = (username) => {
  return { type: GET_USER_INFORMATIONS, username };
};

export const setUserInformations = (userInformations) => {
  return { type: SET_USER_INFORMATIONS, userInformations };
};
export const setGenericRequestState = (genericRequestState) => {
  return { type: SET_GENERIC_REQUEST_STATE, genericRequestState };
};
export const setGenericAuthorizationState = (genericAuthorizationState) => {
  return { type: SET_GENERIC_AUTHORIZATION_STATE, genericAuthorizationState };
};

export const getUserSynchronizationLog = () => {
  return { type: GET_USER_SYNCHRONIZATION_LOG };
};
export const setUserSynchronizationLog = (userSynchronizationLog) => {
  return { type: SET_USER_SYNCHRONIZATION_LOG, userSynchronizationLog };
};

export const getObjectives = () => {
  return { type: GET_OBJECTIVES };
};
export const setObjectives = (objectives) => {
  return { type: SET_OBJECTIVES, objectives };
};

export const getObjectiveByID = (obj_id) => {
  return { type: GET_OBJECTIVE_BY_ID, obj_id };
};
export const setObjectiveByID = (objective) => {
  return { type: SET_OBJECTIVE_BY_ID, objective };
};

export const getEvaluationSystems = () => {
  return { type: GET_EVALUATION_SYSTEMS };
};
export const setEvaluationSystems = (evaluationSystems) => {
  return { type: SET_EVALUATION_SYSTEMS, evaluationSystems };
};

export const getEvaluationPeriods = (sis_id) => {
  return { type: GET_EVALUATION_PERIODS, sis_id };
};
export const setEvaluationPeriods = (evaluationPeriods) => {
  return { type: SET_EVALUATION_PERIODS, evaluationPeriods };
};

export const updateOperationStates = (operations) => {
  return { type: UPDATE_OPERATION_STATES, operations };
};

export const getDocsDisclaimers = () => {
  return { type: GET_DOCS_DISCLAIMERS };
};
export const setDocsDisclaimers = (docsDisclaimers) => {
  return { type: SET_DOCS_DISCLAIMERS, docsDisclaimers };
};

export const updateDocsDisclaimer = (docsDisclaimer) => {
  return { type: UPDATE_DOCS_DISCLAIMER, docsDisclaimer };
};

export const stopEditingDocsDisclaimers = () => {
  return { type: STOP_EDITING_DOCS_DISCLAIMERS };
};

export const uploadSchedule = (uploadData, selectedEntityId) => {
  return { type: UPLOAD_SCHEDULE, uploadData, selectedEntityId };
};
export const stopUploadSchedule = () => {
  return { type: STOP_UPLOAD_SCHEDULE };
};

export const uploadAttendance = (uploadData, selectedEntityId) => {
  return { type: UPLOAD_ATTENDANCE, uploadData, selectedEntityId };
};
export const stopUploadAttendance = () => {
  return { type: STOP_UPLOAD_ATTENDANCE };
};

export const getEntities = () => {
  return { type: GET_ENTITIES };
};
export const setEntities = (entities) => {
  return { type: SET_ENTITIES, entities };
};

export const getEntitiesAttendance = () => {
  return { type: GET_ENTITIES_ATTENDANCE };
};
export const setEntitiesAttendance = (entities) => {
  return { type: SET_ENTITIES_ATTENDANCE, entities };
};

export const getLogs = () => {
  return { type: GET_LOGS };
};
export const setLogs = (logs) => {
  return { type: SET_LOGS, logs };
};

export const getAttendanceLogs = () => {
  return { type: GET_ATTENDANCE_LOGS };
};
export const setAttendanceLogs = (logs) => {
  return { type: SET_ATTENDANCE_LOGS, logs };
};

export const getExportLogs = (logs) => {
  return { type: GET_EXPORT_LOGS, logs };
};
export const setExportLogs = (base64) => {
  return { type: SET_EXPORT_LOGS, base64 };
};
